<script>
	import Icon from './Icon.svelte';
	import { createEventDispatcher, onMount } from 'svelte';
	const dispatch = createEventDispatcher();
	export let data = {};
	export let visible = false;
	export let topLevel = false;
	export let maxWidth = '440px';
	export let customClass = '';
	let dialogRef, dialogWrapperRef;
	const close = () => {
		dispatch('close');
		visible = false;
	};
	export const open = () => {
		dispatch('open');
		visible = true;
	};
	const submit = () => {
		dispatch('submit', data);
		visible = false;
		if (topLevel) {
			// dialogWrapperRef.removeChild(dialogRef);
		}
	};
	onMount(() => {
		if (topLevel) {
			document.body.appendChild(dialogWrapperRef);
		}
	});
</script>

<button on:click={open}>
	<slot name="toggle">Show Dialog</slot>
</button>
<div class="dialogWrapper {customClass}" bind:this={dialogWrapperRef}>
	{#if visible}
		<div
			class="dialog"
			style="--maxWidth:{maxWidth}"
			bind:this={dialogRef}
			on:pointerdown={(e) => e.stopPropagation()}
		>
			<form action="" on:submit|preventDefault={submit}>
				<header>
					<h3>
						<slot name="header">Dialog header</slot>
					</h3>
					<button class="icon" on:click={close}><Icon name="close" /></button>
				</header>
				<div class="dialog-content">
					<slot name="content" />
				</div>
				<footer>
					<div class="close-action" on:click={close}>
						<slot name="close-action">
							<button class="secondary">Cancel</button>
						</slot>
					</div>
					<button class="primary-action" type="submit">
						<slot name="primary-action">
							<button class="primary">Save</button>
						</slot>
					</button>
				</footer>
			</form>
		</div>
		<div class="dialog--bg" />
	{/if}
</div>

<style>
	.dialogWrapper {
		position: absolute;
	}
	.dialog {
		width: 100%;
		max-width: var(--maxWidth, 440px);
		padding: 1.5em;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0px 4px 32px 0px #a1a0a552, 0px 1px 4px 0px #0000001a;
		border-radius: 6px;
		background-color: #fff;
		z-index: 2147483647;
	}
	.dialog--bg {
		content: '';
		display: block;
		position: fixed;
		inset: 0;
		opacity: 0.35;
		z-index: 2147483645;
		background-color: #000;
	}
	.dialog header,
	.dialog footer {
		display: flex;
		align-items: center;
	}
	.dialog header {
		justify-content: space-between;
	}
	.dialog header h3 {
		font-size: 24px;
		margin: 0;
		letter-spacing: 1.5px;
	}
	.dialog form {
		white-space: normal;
	}
	.dialog-content {
		min-height: 40px;
		margin-bottom: 1em;
	}
	.dialog-content :global(input),
	.dialog-content :global(select) {
		width: 100%;
		padding: 12px 6px;
		margin-bottom: 1em;
		border: 1px solid #727178;
		border-radius: 3px;
	}
	.dialog-content :global(label),
	:global(.radio-heading) {
		font-family: 'Overpass';
		font-weight: 800;
		font-size: 14px;
		line-height: 18px;
		color: #727178;
	}
	.dialog footer {
		justify-content: space-between;
	}
	.dialog footer > *:only-child {
		margin-left: 100%;
		transform: translateX(-100%);
	}

	.primary-action {
		background: none;
		border: none;
	}
</style>
